import {LicenseViewModel} from "../api/models";

const DAY_MS = 24 * 60 * 60 * 1000;
// The administrators' licenses list flags review licenses ending within this long.
export const REVIEW_ENDING_SOON_DAYS = 7;

export const isReviewLicense = (license: Pick<LicenseViewModel, 'kind'>) => license.kind === 'review';

// Whether a review license runs out within REVIEW_ENDING_SOON_DAYS (not kept, not revoked, not ended).
export function reviewEndsSoon(license: LicenseViewModel, now: Date = new Date()): boolean {
    if (!isReviewLicense(license) || license.reviewKept || license.revoked || !license.reviewExpiresOn) {
        return false;
    }
    const left = new Date(license.reviewExpiresOn).valueOf() - now.valueOf();
    return left > 0 && left <= REVIEW_ENDING_SOON_DAYS * DAY_MS;
}
